import { defineSlotRecipe } from '@chakra-ui/react';

export const dialogSlotRecipe = defineSlotRecipe({
  slots: [
    'root',
    'trigger',
    'backdrop',
    'positioner',
    'content',
    'header',
    'title',
    'body',
    'footer',
    'closeTrigger',
    'footerPrimaryButton',
    'footerSecondaryButton',
  ],
  base: {
    body: {
      px: '6',
      py: '4',
    },
    header: {
      px: '6',
      pt: '12',
      pb: '2',
      fontSize: 'lg',
      fontWeight: 'bold',
    },
    content: {
      borderRadius: { base: '2xl', md: 'xl' },
    },
    footer: {
      px: '6',
      py: '4',
      justifyContent: 'flex-end',
    },
  },
  variants: {
    variant: {
      error: {
        title: {
          color: 'error.solid',
        },
        footerPrimaryButton: {
          colorPalette: 'error',
        },
        footerSecondaryButton: {
          colorPalette: 'neutral',
        },
      },
      info: {
        title: {
          colorPalette: 'positive',
        },
        footerPrimaryButton: {
          colorPalette: 'positive',
        },
        footerSecondaryButton: {
          colorPalette: 'neutral',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'info',
  },
});
